import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { RefundProvider } from "presentation/store/Refund/RefundProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { RefundMaintenance } from "presentation/view/section/Refund/RefundMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const RefundContMain = () => {
    return <ANAInfoWrapper permission={Permission.REFUND_MAINTENANCE}>
        <MessageBarWrapper>
            <RefundProvider>
                <GridStyles />
                <RefundMaintenance />
            </RefundProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default RefundContMain;